"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var book_1 = require("common/domain/book");
var React = require("react");
var Search = require("react-icons/lib/md/search");
var react_redux_1 = require("react-redux");
var books_1 = require("../redux/books");
var CreateMediaItem_1 = require("./CreateMediaItem");
var ItemsMenu_1 = require("./ItemsMenu");
var Link_1 = require("./Link");
var NoBoxButton_1 = require("./NoBoxButton");
var SimpleBook_1 = require("./SimpleBook");
var TrendingItems_1 = require("./TrendingItems");
var BooksMenu = /** @class */ (function (_super) {
    __extends(BooksMenu, _super);
    function BooksMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BooksMenu.prototype.render = function () {
        var _a = this.props, country = _a.country, createItem = _a.createItem, trendingItems = _a.trendingItems;
        return (React.createElement(ItemsMenu_1.default, __assign({}, this.props, { createItem: React.createElement(CreateMediaItem_1.default, { createItem: createItem, placeholder: "Book URL of Rakuten Books or Better World Books" }), doneButtonText: "read", todoButtonText: "to read" }),
            React.createElement("div", null,
                React.createElement(TrendingItems_1.default, { itemComponent: SimpleBook_1.default, trendingItems: trendingItems }),
                country &&
                    React.createElement(Link_1.default, { href: book_1.convertCountryIntoBookStoreUrl(country) },
                        React.createElement(NoBoxButton_1.default, { icon: React.createElement(Search, null), onClick: function () { return undefined; } }, "Search")))));
    };
    return BooksMenu;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var books = _a.books, environment = _a.environment;
    return (__assign({}, books, environment));
}, books_1.actionCreators)(BooksMenu);



//////////////////
// WEBPACK FOOTER
// ./src/component/BooksMenu.tsx
// module id = 624
// module chunks = 0